import { jbColors } from 'theme/jbColors';

const MuiFilledInput = {
  styleOverrides: {
    root: {
      padding: 0,
      '&:hover': { backgroundColor: jbColors.support.greenSmoke[10] },
    },
    input: {
      backgroundColor: jbColors.support.greenSmoke[10],
      borderRadius: 0,
      padding: '8px 12px !important',
    },
    multiline: {
      padding: 0,
    },
  },
};

export default MuiFilledInput;
